// extracted by mini-css-extract-plugin
export default {"container":"MainCards3Ad_container__V25Ur","img":"MainCards3Ad_img__YH5TA"};